var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.$q.platform.is.desktop
        ? _c("q-table", {
            ref: "table",
            staticClass: "shadow-0",
            attrs: {
              pagination: _vm.server_pagination,
              data: _vm.activities,
              columns: _vm.columns,
              loading: _vm.loading,
              "row-key": "id",
              "no-data-label": _vm.$t("no_data_avaliable"),
              "no-results-label": _vm.$t("no_results_found"),
              "loading-label": _vm.$t("loading_data"),
              "rows-per-page-label": _vm.$t("items_per_page"),
              "rows-per-page-options": [0],
              "hide-bottom": ""
            },
            on: {
              "update:pagination": function($event) {
                _vm.server_pagination = $event
              },
              request: _vm.requestActivities
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "header",
                  fn: function(props) {
                    return _c(
                      "q-tr",
                      { attrs: { props: props } },
                      _vm._l(props.cols, function(col) {
                        return _c(
                          "q-th",
                          { key: col.name, attrs: { props: props } },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t(col.label)) +
                                "\n            "
                            )
                          ]
                        )
                      }),
                      1
                    )
                  }
                },
                {
                  key: "body",
                  fn: function(props) {
                    return [
                      _c(
                        "q-tr",
                        {
                          class: _vm.getRowClass(props.row),
                          attrs: { props: props },
                          nativeOn: {
                            click: function($event) {
                              return _vm.showModal(props.row)
                            }
                          }
                        },
                        [
                          _c(
                            "q-td",
                            { key: "type_title", attrs: { props: props } },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(props.row.type_title) +
                                  "\n                "
                              )
                            ]
                          ),
                          _c(
                            "q-td",
                            { key: "type_slug", attrs: { props: props } },
                            [
                              _c("q-icon", {
                                staticClass: "q-mr-sm",
                                attrs: {
                                  name: _vm.getIcon(props.row.type_slug),
                                  size: "1rem"
                                }
                              }),
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm.$t(_vm.getType(props.row.type_slug))
                                  ) +
                                  "\n                "
                              )
                            ],
                            1
                          ),
                          _c(
                            "q-td",
                            { key: "parent_id", attrs: { props: props } },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm.getParentTitle(props.row.parent_id)
                                  ) +
                                  "\n                "
                              )
                            ]
                          ),
                          _c(
                            "q-td",
                            { key: "avaliable_in", attrs: { props: props } },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.fDate(props.row.avaliable_in)) +
                                  "\n                "
                              )
                            ]
                          ),
                          _c(
                            "q-td",
                            { key: "score", attrs: { props: props } },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    props.row.score > 0 ? props.row.score : ""
                                  ) +
                                  "\n                "
                              )
                            ]
                          ),
                          _c(
                            "q-td",
                            {
                              key: "user_watch",
                              attrs: { props: props, "auto-width": "" }
                            },
                            [
                              props.row.is_blocked
                                ? _c("q-icon", {
                                    attrs: {
                                      name: "fas fa-ban",
                                      size: "1.5rem",
                                      color: "negative"
                                    }
                                  })
                                : props.row.is_expired
                                ? _c("q-icon", {
                                    attrs: {
                                      name: "far fa-clock",
                                      size: "1.5rem",
                                      color: "negative"
                                    }
                                  })
                                : props.row.user_watch || props.row.is_approved
                                ? _c("q-icon", {
                                    attrs: {
                                      name: "far fa-check-circle",
                                      size: "1.5rem",
                                      color: "positive"
                                    }
                                  })
                                : _c("q-icon", {
                                    attrs: {
                                      name: "far fa-circle",
                                      size: "1.5rem",
                                      color: "primary"
                                    }
                                  })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  }
                }
              ],
              null,
              false,
              89442655
            )
          })
        : _vm._e(),
      _vm._l(_vm.activities, function(activity, index) {
        return _c(
          "q-card",
          {
            key: index,
            staticClass: "bg-grey-1 q-mt-md",
            class: _vm.getRowClass(activity)
          },
          [
            _vm.$q.platform.is.mobile
              ? _c(
                  "q-card-main",
                  {
                    staticClass: "relative-position",
                    nativeOn: {
                      click: function($event) {
                        return _vm.showModal(activity)
                      }
                    }
                  },
                  [
                    _c("div", {
                      staticClass: "line-card bg-primary absolute-top"
                    }),
                    _c(
                      "div",
                      { staticClass: "row gutter-sm vertical-middle" },
                      [
                        _c("div", { staticClass: "col-9" }, [
                          _c(
                            "p",
                            [
                              activity.is_blocked
                                ? _c("q-icon", {
                                    attrs: {
                                      name: "fas fa-ban",
                                      size: "1rem",
                                      color: "negative"
                                    }
                                  })
                                : activity.user_watch || activity.is_approved
                                ? _c("q-icon", {
                                    attrs: {
                                      name: "far fa-check-circle",
                                      size: "1rem",
                                      color: "positive"
                                    }
                                  })
                                : _c("q-icon", {
                                    attrs: {
                                      name: "far fa-circle",
                                      size: "1rem",
                                      color: "primary"
                                    }
                                  }),
                              _c(
                                "span",
                                { staticClass: "q-ml-sm q-subheading" },
                                [_vm._v(_vm._s(activity.type_title))]
                              )
                            ],
                            1
                          ),
                          activity.parent_id
                            ? _c("div", [
                                _c("p", { staticClass: "q-caption q-mb-xs" }, [
                                  _vm._v(_vm._s(_vm.$t("requirement")))
                                ]),
                                _c("p", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.getParentTitle(activity.parent_id)
                                    )
                                  )
                                ])
                              ])
                            : _vm._e(),
                          activity.avaliable_in
                            ? _c("div", [
                                _c("p", { staticClass: "q-caption" }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("avaliable_in")) +
                                      " " +
                                      _vm._s(_vm.fDate(activity.avaliable_in))
                                  )
                                ])
                              ])
                            : _vm._e()
                        ]),
                        _c(
                          "div",
                          { staticClass: "col-3 text-right" },
                          [
                            _c("q-icon", {
                              attrs: {
                                name: _vm.getIcon(activity.type_slug),
                                size: "3rem",
                                color: "secondary"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    )
                  ]
                )
              : _vm._e(),
            _vm.$q.platform.is.android && _vm.showOffline(activity)
              ? _c("q-card-separator")
              : _vm._e()
          ],
          1
        )
      }),
      _vm.activities.length == 0
        ? _c(
            "q-card",
            { staticClass: "bg-grey-1 cursor-pointer" },
            [
              _c("q-card-main", { staticClass: "relative-position" }, [
                _c("div", { staticClass: "line-card bg-primary absolute-top" }),
                _c("div", { staticClass: "row gutter-sm" }, [
                  _c("div", { staticClass: "col-12" }, [
                    _c("p", { staticClass: "q-subheading" }, [
                      _vm._v(_vm._s(_vm.$t("no_items_found")))
                    ])
                  ])
                ])
              ])
            ],
            1
          )
        : _vm._e(),
      _c(
        "q-modal",
        {
          attrs: {
            "content-css": { minWidth: "100vw", minHeight: "100vh" },
            "no-backdrop-dismiss": "",
            "no-esc-dismiss": ""
          },
          model: {
            value: _vm.show_modal,
            callback: function($$v) {
              _vm.show_modal = $$v
            },
            expression: "show_modal"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                {
                  style: { display: _vm.display },
                  attrs: { slot: "header" },
                  slot: "header"
                },
                [
                  _vm.type !== "block_general_test" &&
                  _vm.type !== "restart_general_test"
                    ? _c("q-btn", {
                        attrs: {
                          flat: "",
                          round: "",
                          dense: "",
                          icon: "fas fa-times"
                        },
                        on: {
                          click: function($event) {
                            return _vm.shouldHideModal()
                          }
                        }
                      })
                    : _vm._e(),
                  _c("q-toolbar-title", [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.title) +
                        "\n                "
                    )
                  ])
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "layout-padding" },
                [
                  _vm.type == "video"
                    ? _c("course-video", {
                        key: _vm.id,
                        attrs: {
                          activity: _vm.activity,
                          closing: _vm.closing,
                          display: _vm.display
                        },
                        on: {
                          display: function($event) {
                            _vm.display = $event
                          },
                          positionSent: function($event) {
                            return _vm.closeModal()
                          }
                        }
                      })
                    : _vm._e(),
                  _vm.type == "audio"
                    ? _c("course-audio", {
                        key: _vm.id,
                        attrs: { activity: _vm.activity, closing: _vm.closing },
                        on: {
                          positionSent: function($event) {
                            return _vm.closeModal()
                          }
                        }
                      })
                    : _vm._e(),
                  _vm.type == "pdf"
                    ? _c("course-presentation", {
                        key: _vm.id,
                        attrs: {
                          activity: _vm.activity,
                          closing: _vm.closing,
                          display: _vm.display
                        },
                        on: {
                          display: function($event) {
                            _vm.display = $event
                          },
                          positionSent: function($event) {
                            return _vm.closeModal()
                          }
                        }
                      })
                    : _vm._e(),
                  _vm.type == "youtube"
                    ? _c("course-youtube", {
                        key: _vm.id,
                        attrs: { activity: _vm.activity, closing: _vm.closing },
                        on: {
                          positionSent: function($event) {
                            return _vm.closeModal()
                          }
                        }
                      })
                    : _vm._e(),
                  _vm.type == "vimeo"
                    ? _c("course-vimeo", {
                        key: _vm.id,
                        attrs: { activity: _vm.activity, closing: _vm.closing },
                        on: {
                          positionSent: function($event) {
                            return _vm.closeModal()
                          }
                        }
                      })
                    : _vm._e(),
                  _vm.type == "linkedin_slidshare"
                    ? _c("course-slideshare", {
                        key: _vm.id,
                        attrs: { activity: _vm.activity }
                      })
                    : _vm._e(),
                  _vm.type == "scorm"
                    ? _c("course-scorm", {
                        key: _vm.id,
                        attrs: { activity: _vm.activity }
                      })
                    : _vm._e(),
                  _vm.type == "html"
                    ? _c("course-html", {
                        key: _vm.id,
                        attrs: { activity: _vm.activity }
                      })
                    : _vm._e(),
                  _vm.type == "ppt"
                    ? _c("power-point", {
                        key: _vm.id,
                        attrs: { activity: _vm.activity }
                      })
                    : _vm._e(),
                  _vm.type == "restart_test" ||
                  _vm.type == "block_test" ||
                  _vm.type == "conventional_test" ||
                  _vm.type == "evaluated_quiz" ||
                  _vm.type == "unevaluated_quiz"
                    ? _c("course-test", {
                        key: _vm.id,
                        attrs: { activity: _vm.activity, closing: _vm.closing },
                        on: {
                          clearTest: function($event) {
                            return _vm.closeModal()
                          }
                        }
                      })
                    : _vm._e(),
                  _vm.type === "block_general_test" ||
                  _vm.type === "restart_general_test"
                    ? _c("course-general-test", {
                        key: _vm.id,
                        attrs: { activity: _vm.activity },
                        on: { closeTest: _vm.closeModal }
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "q-dialog",
        {
          on: {
            ok: function($event) {
              return _vm.removeDownload()
            },
            cancel: function($event) {
              _vm.confirm_remove_download = false
            }
          },
          scopedSlots: _vm._u([
            {
              key: "buttons",
              fn: function(props) {
                return [
                  _c("q-btn", {
                    attrs: { color: "primary", label: _vm.$t("cancel") },
                    on: {
                      click: function($event) {
                        _vm.confirm_remove_download = false
                      }
                    }
                  }),
                  _c("q-btn", {
                    attrs: { color: "negative", label: _vm.$t("remove") },
                    on: {
                      click: function($event) {
                        return _vm.removeDownload()
                      }
                    }
                  })
                ]
              }
            }
          ]),
          model: {
            value: _vm.confirm_remove_download,
            callback: function($$v) {
              _vm.confirm_remove_download = $$v
            },
            expression: "confirm_remove_download"
          }
        },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("remove_download")))
          ]),
          _c("span", { attrs: { slot: "message" }, slot: "message" }, [
            _vm._v(_vm._s(_vm.$t("confirm_remove_the_download")))
          ])
        ]
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }